"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _booking = require("@/api/goods_activity/booking.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BookingTablePane',
  components: {},
  data: function data() {
    return {
      loading: false,
      listQuery: {
        page: 1,
        limit: 20,
        keywords: ''
      },
      tableKey: 0,
      selectedRows: [],
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleBatch: function handleBatch() {
      // 传递选中的门店列表，如果没有选中任何门店则传递空数组
      this.$emit('toConfig', this.selectedRows);
    },
    handleEdit: function handleEdit(row) {
      var rows = [row];
      this.$emit('toConfig', rows);
    },
    handleToggleEnable: function handleToggleEnable(row) {
      var _this = this;
      // 需要使用storeId作为fnId传递给后端
      (0, _booking.toggleEnable)(row.storeId, row.markForEnable).then(function () {
        _this.$message.success('状态修改成功');
      }).catch(function () {
        // 失败时恢复原状态
        row.markForEnable = !row.markForEnable;
      });
    },
    search: function search() {
      this.handleFilter();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this2 = this;
      this.loading = true;
      (0, _booking.bookingPage)(this.listQuery).then(function (res) {
        _this2.tableData = res.records;
        _this2.total = res.total;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }
};